/*
  File to assist in loading stubs in autoStubLoader.
  Set where you want the stub to be displayed.

  go to src/index.js and load in...
  ex. 'import "./pages/stubName/stubName";'
*/

//import run from '../../../utilities/run';
//import attachStubExample from './loadExample';
import "./famf.js";
import "./famfLogic.js";
import "./fedexAccountManagement.less";



// WEBPACK FOOTER //
// ./src/pages/fedexAccountManagement/index.js